// Helpers compartilhados do módulo financeiro (BDM-886).

export const ENTRY_TYPES = [
    { label: 'A receber', value: 'receivable' },
    { label: 'A pagar', value: 'payable' },
];

export const ENTRY_STATUSES = [
    { label: 'Em aberto', value: 'open' },
    { label: 'Parcial', value: 'partial' },
    { label: 'Quitado', value: 'settled' },
    { label: 'Cancelado', value: 'canceled' },
];

export const getEntryTypeLabel = type =>
    ENTRY_TYPES.find(option => option.value === type)?.label ?? type;

export const getEntryStatusLabel = status =>
    ENTRY_STATUSES.find(option => option.value === status)?.label ?? status;

// Principal do título já coberto pelas baixas (centavos):
// amount - interest + discount de cada baixa.
export const getSettledAmount = entry =>
    (entry.settlements ?? []).reduce(
        (sum, settlement) => sum + settlement.amount - settlement.interest + settlement.discount,
        0
    );

export const getRemainingAmount = entry =>
    Math.max(0, entry.amount - getSettledAmount(entry));

export const isSettleable = entry =>
    ['open', 'partial'].includes(entry.status);

// Plano de contas: o código, quando existe, vem na frente do nome.
export const getCategoryLabel = category =>
    category.code ? `${category.code} ${category.name}` : category.name;

// Achata a árvore na ordem do plano de contas (cada pai seguido dos filhos),
// carregando o nível em `depth` para quem precisa indentar.
export const flattenCategories = (categories, parentId = null, depth = 0) =>
    categories
        .filter(category => (category.parent_id ?? null) === parentId)
        .flatMap(category => [
            { ...category, depth },
            ...flattenCategories(categories, category.id, depth + 1),
        ]);

// Só as analíticas aceitam lançamento — a sintética existe para somar as filhas.
export const isLeafCategory = category => !(category.children_count > 0);
